// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 1440px) and (max-width: 2560px) {
  .fact_check_description_one {
    width: 450px;
    font-size: 1.6vh;
  }
  .policies_description {
    font-size: 1.8vh;
  }
  .funding_container_right {
    width: 50%;
    margin: 0px 0px 20px 30px;
    padding: 30px 70px;
    border-radius: 12px;
  }
  .funding_container {
    justify-content: space-between;
  }
  .funding_right_head {
    font-size: 16px;
  }
  .award_list_image {
    width: 280px;
  }
  .award_list_two_img {
    height: 16vh;
  }
  .our_mission_right_content {
    font-size: 17px;
  }
  .our_mission_rightmeet_the_team_right_para {
    font-size: 19px;
  }
  .ifcn_description {
    font-size: 17px;
  }
  .fight_fake_news_head {
    font-size: 14px;
  }
  .fight_fake_news_hash_val {
    font-size: 42px;
  }
  .fight_fake_news_hash {
    font-size: 84px;
  }
  .figh_fake_news_note {
    font-size: 12px;
  }
  .fact_check_heading_dt {
    font-size: 25px;
  }
  .fact_check_description {
    font-size: 16px;
  }
  .fact_check_description_one {
    font-size: 15px;
  }
  .policies_description {
    font-size: 21px;
  }
  .funding_button {
    font-size: 21px;
    height: 5vh;
  }
  .award_list_two_img {
    height: 30vh;
  }
  .award_list_one_description {
    font-size: 21px;
  }
  .award_list_one_content {
    font-size: 15px;
  }
  .team_members_profile_card {
    display: flex;
    width: 100%;
    margin-bottom: 70px;
    padding: 15px;
    flex-direction: row;
    gap: 10%;
  }
  .hide_about_page_in_web {
    display: none;
  }
  .about_us_join_use_card_container {
    display: none;
  }
  .profile_img {
    height: 250px;
    width: 250px;
  }
  .team_members_profile {
    margin-top: 220px;
  }
  .profile_name_container,
  .profile_role_container {
    min-width: 260px;
    max-width: 300px;
  }
  .profile_name {
    font-size: 14px;
  }
  .profile_role {
    font-size: 13px;
    line-height: 22.6px;
  }
  .team_member_details_container {
    padding: 75px;
  }
  .aboutus_banner_container {
    padding: 5px 50px 30px 85px;
  }
  .ifcn_certificates_notes{
    display: flex;
    align-items: end;
    gap: 20px;
  }
  .notes_text_size{
    font-size: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_1440_1999/screen_1440_2559_aboutus.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@media only screen and (min-width: 1440px) and (max-width: 2560px) {\r\n  .fact_check_description_one {\r\n    width: 450px;\r\n    font-size: 1.6vh;\r\n  }\r\n  .policies_description {\r\n    font-size: 1.8vh;\r\n  }\r\n  .funding_container_right {\r\n    width: 50%;\r\n    margin: 0px 0px 20px 30px;\r\n    padding: 30px 70px;\r\n    border-radius: 12px;\r\n  }\r\n  .funding_container {\r\n    justify-content: space-between;\r\n  }\r\n  .funding_right_head {\r\n    font-size: 16px;\r\n  }\r\n  .award_list_image {\r\n    width: 280px;\r\n  }\r\n  .award_list_two_img {\r\n    height: 16vh;\r\n  }\r\n  .our_mission_right_content {\r\n    font-size: 17px;\r\n  }\r\n  .our_mission_rightmeet_the_team_right_para {\r\n    font-size: 19px;\r\n  }\r\n  .ifcn_description {\r\n    font-size: 17px;\r\n  }\r\n  .fight_fake_news_head {\r\n    font-size: 14px;\r\n  }\r\n  .fight_fake_news_hash_val {\r\n    font-size: 42px;\r\n  }\r\n  .fight_fake_news_hash {\r\n    font-size: 84px;\r\n  }\r\n  .figh_fake_news_note {\r\n    font-size: 12px;\r\n  }\r\n  .fact_check_heading_dt {\r\n    font-size: 25px;\r\n  }\r\n  .fact_check_description {\r\n    font-size: 16px;\r\n  }\r\n  .fact_check_description_one {\r\n    font-size: 15px;\r\n  }\r\n  .policies_description {\r\n    font-size: 21px;\r\n  }\r\n  .funding_button {\r\n    font-size: 21px;\r\n    height: 5vh;\r\n  }\r\n  .award_list_two_img {\r\n    height: 30vh;\r\n  }\r\n  .award_list_one_description {\r\n    font-size: 21px;\r\n  }\r\n  .award_list_one_content {\r\n    font-size: 15px;\r\n  }\r\n  .team_members_profile_card {\r\n    display: flex;\r\n    width: 100%;\r\n    margin-bottom: 70px;\r\n    padding: 15px;\r\n    flex-direction: row;\r\n    gap: 10%;\r\n  }\r\n  .hide_about_page_in_web {\r\n    display: none;\r\n  }\r\n  .about_us_join_use_card_container {\r\n    display: none;\r\n  }\r\n  .profile_img {\r\n    height: 250px;\r\n    width: 250px;\r\n  }\r\n  .team_members_profile {\r\n    margin-top: 220px;\r\n  }\r\n  .profile_name_container,\r\n  .profile_role_container {\r\n    min-width: 260px;\r\n    max-width: 300px;\r\n  }\r\n  .profile_name {\r\n    font-size: 14px;\r\n  }\r\n  .profile_role {\r\n    font-size: 13px;\r\n    line-height: 22.6px;\r\n  }\r\n  .team_member_details_container {\r\n    padding: 75px;\r\n  }\r\n  .aboutus_banner_container {\r\n    padding: 5px 50px 30px 85px;\r\n  }\r\n  .ifcn_certificates_notes{\r\n    display: flex;\r\n    align-items: end;\r\n    gap: 20px;\r\n  }\r\n  .notes_text_size{\r\n    font-size: 17px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
